// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"54":"a5a6818b739b4db341ae","231":"c95c055abdde965ba145","408":"c87112cda31d52a82f82"}[chunkId] + ".js";
};